module.exports = __webpack_public_path__ + "img/404-item-1.e9ca66c9.png";